
;var RotateButton = function( chapter ) {

  var hammer = new Hammer(chapter[0]);

  hammer.on('pan', onChapterTouch);

  function onChapterTouch() {
    $( chapter ).find( '.rotateButton' ).addClass( 'startSimulation' );

    setTimeout( function() {
      $( chapter ).find( '.rotateButton' ).addClass( 'displayNone' );
    }, 500);
  };

};
